import React, { useEffect } from "react";
import { connect } from "react-redux";
import { actionCreators } from "./action";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Button from "@material-ui/core/Button";

import BottomPanel from '../BottomPanel';

const CreateTask = props => {
  const keydownHandler = e => {
    const nChar = 78;
    const escChar = 27;
    if (!props.isFormIsOpen) {
      // if (e.keyCode === nChar) {
      //   props.openNewTaskForm();
      //   document.removeEventListener("keydown", keydownHandler);
      // }
    }else{
      if (e.keyCode === escChar) {
        props.closeTaskForm();
        document.removeEventListener("keydown", keydownHandler);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", keydownHandler);
  });


  return props.isFab ? (
   
      <BottomPanel isFormIsOpen={props.isFormIsOpen} />
      
  ) : (
    <Button
      variant="contained"
      color="primary"
      onClick={() => props.openNewTaskForm()}
    >
      <AddCircleIcon />
      New item 
    </Button>
  );
};

const mapStateToProps = state => ({
  isFormIsOpen: state.isFormIsOpen.isFormIsOpen,
});

export default connect(mapStateToProps, actionCreators)(CreateTask);
